import Menu from "./Menu"
import Disclosure from "./MenuDisclosure"
import Group from "./MenuGroup"
import Item from "./MenuItem"
import Separator from "./MenuSeparator"
import Title from "./MenuTitle"

export default Object.assign(Menu, {
  Disclosure,
  Group,
  Item,
  Separator,
  Title
})
